import $ from 'jquery';

jQuery(function () {
  $('.faq-block__accordion').first().addClass('active');
  $('.faq-block__tab-title').first().addClass('active');

  $('.faq-block__tab-title').on('click', function () {
    var accordionId = $(this).data('accordion');
    var accordionTab = $(
      '.faq-block__accordion[data-accordion="' + accordionId + '"]'
    );

    if (!accordionTab.hasClass('active')) {
      $('.faq-block__accordion').removeClass('active');
      $('.faq-block__tab-title').removeClass('active');

      accordionTab.addClass('active');
      $(this).addClass('active');
    }
  });
});

jQuery(function () {
  $('.faq-block__accordion-card').first().addClass('active');
    $('.faq-block__accordion-toggle').on('click', function () {
    let card = $(this).closest('.faq-block__accordion-card');
    card.toggleClass('active');
    $('.faq-block__accordion-card').not(card).removeClass('active');
  });
});
